import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  robots?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
}

export default function SEO({
  title,
  description,
  keywords,
  canonical,
  robots = 'index, follow',
  ogTitle,
  ogDescription,
  ogType = 'website',
  ogUrl,
}: SEOProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (attrKey: string, attrVal: string, content: string) => {
      let el = document.querySelector(`meta[${attrKey}="${attrVal}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attrKey, attrVal);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', description);
    setMeta('name', 'robots', robots);
    if (keywords) setMeta('name', 'keywords', keywords);
    setMeta('property', 'og:title', ogTitle ?? title);
    setMeta('property', 'og:description', ogDescription ?? description);
    setMeta('property', 'og:type', ogType);

    const resolvedOgUrl = ogUrl ?? canonical;
    if (resolvedOgUrl) setMeta('property', 'og:url', resolvedOgUrl);

    let linkEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical) {
      if (!linkEl) {
        linkEl = document.createElement('link');
        linkEl.setAttribute('rel', 'canonical');
        document.head.appendChild(linkEl);
      }
      linkEl.setAttribute('href', canonical);
    }
  }, [title, description, keywords, canonical, robots, ogTitle, ogDescription, ogType, ogUrl]);

  return null;
}
